import getEnv from "../tools/get-env";

/**
 * The same identity admin-ui reports: DEPLOY_ENV (development / production)
 * as the environment, not the build mode, which is "production" in every
 * cluster. env.sh writes unset keys as "", hence `||` for the sample rate.
 */
export function faroOptions() {
  return {
    collectorUrl: getEnv("FARO_COLLECT_URL"),
    appName: "monitor-ui",
    appVersion: import.meta.env.VITE_APP_VERSION,
    environment: getEnv("DEPLOY_ENV"),
    sessionSampleRate: Number(getEnv("FARO_SESSION_SAMPLE_RATE") || "1"),
  };
}

/**
 * Initialises Grafana Faro frontend observability.
 *
 * Exported as a named function so tests can import and invoke it in isolation,
 * and to keep index.tsx free of the async IIFE boilerplate. The caller in
 * index.tsx uses `void tryInitFaro()` — no await, no promise propagation.
 *
 * The try/catch is load-bearing: it prevents a ChunkLoadError from the Faro
 * dynamic import reaching the window error/unhandledrejection handlers in
 * index.tsx, which would otherwise trigger a page reload. Telemetry must
 * never be able to take the app down.
 */
export async function tryInitFaro(): Promise<void> {
  try {
    const { initFaro, trackRouteChanges } = await import("@rareconsult/faro");
    const faro = initFaro(faroOptions());
    if (faro) trackRouteChanges();
  } catch {
    // Faro chunk unavailable — telemetry off, app continues.
  }
}
